import LoadingButton from './LoadingButton'

const ButtonsModal = ({ onClose, loading, formControl }) => {
  return (
    <div className="row justify-content-end mb-4">
      <div className='col-auto'>
        <LoadingButton type="button" className="btn btn-secondary" onClick={onClose}>
          Close
        </LoadingButton>
      </div>
      <div className='col-auto'>
        <LoadingButton type="submit" form={formControl} className="btn btn-primary" disabled={loading}>
          Save
        </LoadingButton>
      </div>
    </div>
  )
}

export default ButtonsModal
